import api from "./api.service";

export function onboard(payload, options = {}) {
  return api.post("/web/developers/onboard", payload, options);
}

export function getMe(options = {}) {
  return api.get("/web/developers/me", options);
}

export function updateMe(payload, options = {}) {
  return api.patch("/web/developers/me", payload, options);
}

export function regenerateKey(options = {}) {
  return api.post("/web/developers/me/regenerate-key", undefined, options);
}

export function getUsage(options = {}) {
  return api.get("/web/developers/me/usage", options);
}

export function uploadAvatar(imageData, options = {}) {
  return api.post("/web/developers/me/avatar", { imageData }, options);
}

export function deleteMe(options = {}) {
  return api.delete("/web/developers/me", options);
}

const developersApi = {
  onboard,
  getMe,
  updateMe,
  regenerateKey,
  getUsage,
  uploadAvatar,
  deleteMe,
};

export default developersApi;
